import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

const withdrawalSearchSchema = z.object({
  tab: z.enum(['settlement', 'reconciliation', 'withdrawal', 'unwithdrawn']).optional(),
  withdrawal_status: z.string().optional(),
  start_at: z.string().optional(),
  end_at: z.string().optional(),
  page: z.union([z.string(), z.number()]).optional(),
  limit: z.union([z.string(), z.number()]).optional(),
});

export const withdrawalRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/withdrawal',
  validateSearch: withdrawalSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/withdrawal/withdrawal-page')),
});

export const detailWithdrawalRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/withdrawal/$id',
  component: lazyRouteComponent(() => import('@/pages/withdrawal/withdrawal-detail-page')),
});
